module.exports = __webpack_public_path__ + "img/jietu1.162ae44c.png";